import * as types from "./mutation-types";

const mutations = {
    [types.CLEAR](state) {
        state.token = null;
        state.auth = null;
    },
    [types.SET_LOCALE](state, locale) {
        state.locale = locale;
    },
    [types.SET_API_CONFIG](state, apiConfig) {
        state.apiConfig = apiConfig;
    },
    [types.SET_TOKEN](state, token) {
        state.token = token;
    },
    [types.SET_NETWORK_STATE](state, networkState) {
        state.networkState = networkState;
    },
    [types.SET_AUTH_INFO](state, authInfo) {
        state.auth = authInfo;
    },
    [types.SET_FOOD_CLASSIFY](state, foodClassify){
        state.foodClassify = foodClassify;
        sessionStorage.setItem("foodclassifyinfo", JSON.stringify(foodClassify))
        // console.log(state.foodClassify)
    },
    [types.SET_FOOD_INFO](state,foodInfo){
        state.foodInfo = foodInfo;
        // sessionStorage.setItem("foodinfo",JSON.stringify(foodInfo))
        // console.log(state.foodInfo);
    },
    [types.SET_SEQ](state,seq){
        state.seq = seq;
        sessionStorage.setItem("foodinfo", JSON.stringify(state.seq))
        // console.log('seq',state.seq)
    }
}

export default mutations;